import React, { Component } from 'react';
import ScenesComponent from './ScenesComponent.js';
import SubSequenceMixComponent from './SubSequenceMixComponent.js';
import StepsVisualizer from './StepsVisualizer.js';
import MixModules from './MixModules.js';

const SubMixComponent = (props) => {
    return (
        <div className="global-mix-container">
          <div className="sub-sequences-mix-container">
            {props.sequencerEngine.subSequences
             .filter(x => !x.isTrack)
                    .map(
                    (sub, i) =>
                        <SubSequenceMixComponent
                              key={"sub-mix-" + i}
                              sequencerEngine={props.sequencerEngine}
                              i={i}
                              subSequence={sub}/>
                )}
                <ScenesComponent sequencerEngine={props.sequencerEngine}/>
                <MixModules sequencerEngine={props.sequencerEngine}/>
            </div>
            </div>
        );
};

export default SubMixComponent;

